import { logWrapper } from '../utils';

export default function cut(runtimeConstant) {
  function run() {
    try {
      return function (value, wordwise, max, tail) {
        if (!value) return '';
        max = parseInt(max, 10);

        if (!max) return value;
        if (value.length <= max) return value;

        value = value.substr(0, max);

        if (wordwise) {
          var lastspace = value.lastIndexOf(' ');

          if (lastspace !== -1) {
            if (
              value.charAt(lastspace - 1) === '.' ||
              value.charAt(lastspace - 1) === ','
            )
              lastspace = lastspace - 1;
            value = value.substr(0, lastspace);
          }
        }
        return value + (tail || ' …');
      };
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }

  // Wrap the setup function with logWrapper for debugging purposes
  return logWrapper(run, runtimeConstant.isDebugFilters)();
}
